"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatOptionalLabel = exports.formatLabel = void 0;

var formatLabel = function formatLabel(label) {
  var optional = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return optional ? "".concat(label, " (optional)") : label;
};

exports.formatLabel = formatLabel;

var formatOptionalLabel = function formatOptionalLabel(label) {
  return "".concat(label, " (optional)");
};

exports.formatOptionalLabel = formatOptionalLabel;